import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-historia',
  standalone: true,
  imports: [],
  templateUrl: './historia.component.html',
  styleUrls: ['./historia.component.scss'] // Asegúrate de que esta línea sea correcta
})
export class HistoriaComponent implements OnInit {

  ngOnInit() {
    this.animateOnScroll(); // Ejecuta la función en la carga inicial para los elementos visibles
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.animateOnScroll();
  }

  private animateOnScroll() {
    // Selecciona los elementos específicos en el DOM para añadirles la clase fade-in
    const elements = document.querySelectorAll('.historia-contenido, .servicios-experiencia-contenido, .reserva-grupos-contenido');

    elements.forEach((element: Element) => {
      const rect = element.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight - 100; // Ajusta el umbral según tus necesidades

      if (isVisible) {
        element.classList.add('fade-in');
      }
    });
  }
}
